<template>
  <div
    class="flex flex-col items-center w-full gap-4 py-8"
    :style="{ minHeight: 'calc(100vh - 2.5rem - 3.5rem - 5rem)' }"
  >
    <div
      class="flex flex-col gap-4 px-10 w-152"
      :class="defaultProblemBehaviors.length === 0 ? 'pt-10 pb-2' : 'py-10'"
    >
      <div class="flex justify-between">
        <BlTextSubtitle1 text="Add problem behaviors" />
        <BlInputButton
          label="Add behavior"
          @clicked="onAddProblemBehavior"
          v-if="!allProblemBehaviorsUsed"
        />
        <BlTooltip
          v-else
          tooltip="You’ve reached the limit for problem behaviors and can’t create a new one."
        >
          <BlInputButton label="Add behavior" disabled />
        </BlTooltip>
      </div>
      <div
        v-if="
          Array.isArray(defaultProblemBehaviors) &&
            defaultProblemBehaviors.length > 0
        "
        v-for="problemBehavior in sortedProblemBehaviors"
        :key="`problem-behavior-item-${problemBehavior.key}`"
      >
        <ProblemBehaviorItem
          :problemBehavior="problemBehavior"
          kind="client"
          :problemBehaviors="problemBehaviors"
          :defaultProblemBehaviors="defaultProblemBehaviors"
          @update="$emit('updateProblemBehavior', $event)"
          @delete="$emit('removeProblemBehavior', $event)"
          :readOnly="!currentUser.role.includes('admin')"
        />
      </div>
    </div>
    <div
      v-if="defaultProblemBehaviors.length === 0"
      class="flex items-center gap-3 p-2 rounded bg-cornflower-200"
      style="width: 39rem"
    >
      <BlIcon icon="Info-blue" />
      <BlTextBody2
        class="text-cornflower-800"
        text="No problem behavior will be recorded for this target. Add one if needed."
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import BlInputButton from "../../../BlInputButton.vue";
import BlTextSubtitle1 from "../../../BlTextSubtitle1.vue";
import ProblemBehaviorItem from "../../../repository/sbt/ProblemBehaviorItem.vue";
import BlTooltip from "../../../BlTooltip.vue";
import BlTextBody2 from "../../../BlTextBody2.vue";
import BlIcon from "../../../BlIcon.vue";

export default {
  name: "NewProblemOverlay",
  components: {
    BlTextSubtitle1,
    BlInputButton,
    ProblemBehaviorItem,
    BlTooltip,
    BlTextBody2,
    BlIcon
  },
  props: {
    problemBehaviors: { type: Array, default: () => [] },
    defaultProblemBehaviors: { type: Array, default: () => [] },
    sbtStep: { type: Number, default: 0 },
    typeInput: { type: String, default: "" }
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["currentUser"]),

    allProblemBehaviorsUsed() {
      return (
        this.defaultProblemBehaviors.length >= this.problemBehaviors.length
      );
    },
    sortedProblemBehaviors() {
      return [...this.defaultProblemBehaviors].sort(
        (a, b) => a.position - b.position
      );
    }
  },
  methods: {
    onAddProblemBehavior() {
      this.$emit("addProblemBehavior");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/clients/target/overlay/NewProblemOverlay.vue